<script lang="ts">
  import { slaChip } from '$lib/utils/format';
  import Chip from '$lib/components/ui/Chip.svelte';

  const { status, createdAt }: { status: string; createdAt: string } = $props();
  const sla = $derived(slaChip(status, createdAt));
</script>

{#if sla}
  <Chip label={sla.label} kind={sla.kind} />
{/if}
